import { Dialog, DialogContent } from "./dialog.jsx";

export default function ForceRazeenPlusModal() {
  return (
    <Dialog modal open={true}>
      <DialogContent className="max-w-[45rem]" withCloseButton={false}>
        <div className="w-full">
          <img src="/new-razeen.png" alt="" />
        </div>

        <div className="flex flex-col gap-2 items-center justify-center text-center">
          <div className="text-black text-[2rem]">
            You’re Now on <span className="font-bold">Razeen+</span> 🚀
          </div>

          <div className="text-[#72707A] mt-2">
            We’ve upgraded your experience! You’re now using Razeen+. All your
            previous data has been securely moved—no action is needed from your
            side. Click below to seamlessly continue your work on the new
            system.
          </div>

          <a
            href="https://app.razeen.io"
            className="mt-4 w-full bg-[#5E45FF] text-[#fff] p-3 rounded-full font-bold"
          >
            Continue to Razeen+
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
}
